// extracted by mini-css-extract-plugin
module.exports = {"card":"SingerCard_card__2TiW9","img":"SingerCard_img__2zgwN","info":"SingerCard_info__2CX7x","icon":"SingerCard_icon__HhHnH"};